import React, { useContext, useEffect } from 'react';
import LeadContext from '../../../Portfolio/subrouters/Buyer/providers/Lead/Lead.context';
import MessagingRouter from '../../Messaging.router';
import MessagingProvider from '../../providers/Messaging';
import { useLockScrollOnReroute } from 'hooks/useLockScrollOnReroute';
import HelmetWrapper from 'components/HelmetWrapper';

import './MessageBuyerWrapper.styles.scss';

const MessagingBuyerWrapper: React.FC = () => {
  const { dealRoom, listing, unreadMessagesCount, updateUnreadMessagesCount } =
    useContext(LeadContext);

  const { _id: listingId, listingEnquiryId } = listing || {};
  const { portfolioName } = dealRoom || {};

  useLockScrollOnReroute();

  useEffect(() => {
    if (unreadMessagesCount) updateUnreadMessagesCount(0);
  }, [unreadMessagesCount, updateUnreadMessagesCount]);

  return (
    <MessagingProvider
      messagingPortfolioProps={{ listingId, listingEnquiryId }}
    >
      <HelmetWrapper title={`Chat - ${portfolioName}`} />
      <MessagingRouter className="buyer-messaging-router" />
    </MessagingProvider>
  );
};

export default MessagingBuyerWrapper;
